import Cookies from "js-cookie";
import API from "./API";

export default class BrieCostTrackerAPI {
  static async getOverAllCloudCosts(
    tenantID: string,
    month: number,
    year: number,
    type: "month" | "year" = "month"
  ) {
    return API._bearerRequest(
      "get",
      `/tenant/brie-cost-tracker/${tenantID}?month=${month}&year=${year}&type=${type}`,
      null,
      Cookies.get(`authenticationToken`)
    );
  }
}
